import { Item } from '../../search';

export interface ItemsHighlights {
	[id: string]: {
		start: number;
		end: number;
	};
}

export const getItemHighlights = (items: Item[], text: string): ItemsHighlights => {
	return items.reduce((accumulator, item) => {
		const index = item.value?.toLowerCase().indexOf(text?.toLowerCase());
		if (index > -1) {
			accumulator[item.id] = {
				start: index,
				end: index + text.length
			};
		}
		return accumulator;
	}, {});
};
